import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('MEDICAL GAS TANKS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class MedicalGasTanksService extends ApiBaseService<any> {

  constructor() {
    super('medicalGasTanks');
    log.debug('Servicio de Catálogo de Tanques de Gas inicializado');
  }
}
